/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServerLengthModelVariant } from './ServerLengthModelVariant';
import {
    ServerLengthModelVariantFromJSON,
    ServerLengthModelVariantFromJSONTyped,
    ServerLengthModelVariantToJSON,
    ServerLengthModelVariantToJSONTyped,
} from './ServerLengthModelVariant';

/**
 * 
 * @export
 * @interface ComputeLengthRequest
 */
export interface ComputeLengthRequest {
    /**
     * 
     */
    captureIds?: Array<string> | null;
    /**
     * 
     */
    allKeeps?: boolean;
    /**
     * 
     */
    modelVariant?: ServerLengthModelVariant;
}



/**
 * Check if a given object implements the ComputeLengthRequest interface.
 */
export function instanceOfComputeLengthRequest(value: object): value is ComputeLengthRequest {
    return true;
}

export function ComputeLengthRequestFromJSON(json: any): ComputeLengthRequest {
    return ComputeLengthRequestFromJSONTyped(json, false);
}

export function ComputeLengthRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeLengthRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureIds': json['capture_ids'] === undefined ? undefined : json['capture_ids'] === null ? null : json['capture_ids'],
        'allKeeps': json['all_keeps'] == null ? undefined : json['all_keeps'],
        'modelVariant': json['model_variant'] == null ? undefined : ServerLengthModelVariantFromJSON(json['model_variant']),
    };
}

export function ComputeLengthRequestToJSON(json: any): ComputeLengthRequest {
    return ComputeLengthRequestToJSONTyped(json, false);
}

export function ComputeLengthRequestToJSONTyped(value?: ComputeLengthRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_ids': value['captureIds'],
        'all_keeps': value['allKeeps'],
        'model_variant': ServerLengthModelVariantToJSON(value['modelVariant']),
    };
}

